import { render, staticRenderFns } from "./relationshipList.vue?vue&type=template&id=f2faf664&"
import script from "./relationshipList.vue?vue&type=script&lang=js&"
export * from "./relationshipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports